import { useQuery } from '@tanstack/react-query';
import { usersService } from '../services/users.service';

const USERS_KEY = 'tenant-users';

/**
 * Hook pour récupérer tous les utilisateurs du tenant
 */
export function useTenantUsers() {
  return useQuery({
    queryKey: [USERS_KEY],
    queryFn: () => usersService.getAll(),
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
}
